import React from 'react'
import classes from "./TimePill.module.css"
import clsx from "clsx"

const TimePill = ({data, onClick, active }) => {
  return (
    <div 
      onClick={(e)=>{
        if(data?.isBlocked){
          return
        }
        onClick(e)
      }}
      className={clsx(classes.wrapper, {
        [classes.blocked]: data?.isBlocked,
        [classes.active]: active
      })}
    >
      {data?.label}
    </div>
  )
}

export default TimePill